import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import { RulesetResult, HasOtherOutstandingLoanObligations } from '../rules';

class UploadOrListDebtObligationsRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    if (HasOtherOutstandingLoanObligations.evaluate(data))
      return RulesetResult.REQUIRED;

    return RulesetResult.HIDDEN;
  };
}

export default new UploadOrListDebtObligationsRuleset();
